var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLifecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.051 27.8344C14.8364 29.5246 19.3451 29.4328 23.206 27.1894C29.6207 23.4621 31.8185 15.2069 28.115 8.75098L27.7205 8.06337M4.88462 22.249C1.1811 15.7931 3.37893 7.53795 9.79363 3.81062C13.6546 1.56717 18.1632 1.47538 21.9486 3.16556M1.5 22.3818L5.81074 23.5443L6.9658 19.2059M26.0342 11.7933L27.1893 7.45482L31.5 8.61731",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLifecycle);
export default __webpack_public_path__ + "static/media/ai-lifecycle.4423c9d62d172de8a18c9b3fc598a724.svg";
export { ForwardRef as ReactComponent };